import type {
  SpotlightInsight,
  SpotlightProduct,
} from '../insights/spotlight-details/spotlightDetails.types';
import type {
  CustomerSpotlight,
  CustomerSpotlightListItem,
  CustomerSpotlightProductDetail,
} from './spotlights.types';

function adaptProductDetails(
  productDetails: CustomerSpotlightProductDetail[] | undefined
): SpotlightProduct[] {
  if (!Array.isArray(productDetails)) {
    return [];
  }

  return productDetails.map((productDetail) => ({
    id: productDetail.id,
    name: productDetail.product,
    affectedVersion: productDetail.affectedVersion,
    customerVersion: productDetail.customerVersion,
    status: productDetail.status as SpotlightProduct['status'],
    statusReason: productDetail.statusReason,
    customerSpotlightFeedback: productDetail.customerSpotlightFeedback,
  }));
}

export function adaptCustomerSpotlightToInsight(
  customerSpotlight: CustomerSpotlight
): SpotlightInsight {
  return {
    spotlightName: customerSpotlight.spotlight?.spotlightName ?? '',
    reasonName: '',
    reasonDescription: customerSpotlight.description,
    dataSource: customerSpotlight.dataSource,
    accountId: customerSpotlight.accountId,
    cve: customerSpotlight.spotlight?.cve
      ? [customerSpotlight.spotlight.cve]
      : [],
    vendorAdvisoryLinks: customerSpotlight.spotlight?.vendorAdvisoryLinks ?? [],
    mostImpactedCF: customerSpotlight.mostImpactedCF,
    importance: customerSpotlight.severity,
    created: customerSpotlight.createdTs,
    status: customerSpotlight.status as SpotlightInsight['status'],
    products: adaptProductDetails(customerSpotlight.productDetails),
  };
}

export function adaptListItem(
  customerSpotlight: CustomerSpotlight
): CustomerSpotlightListItem {
  return {
    insightId: customerSpotlight.id,
    id: customerSpotlight.id,
    isSpotlight: true,
    reasonDescription: customerSpotlight.description,
    importance: customerSpotlight.severity,
    created: customerSpotlight.createdTs,
    dataSource: customerSpotlight.dataSource,
    mostImpactedCF: customerSpotlight.mostImpactedCF,
    status: customerSpotlight.status,
    cve: customerSpotlight.cve,
    products: adaptProductDetails(customerSpotlight.productDetails),
  };
}
